import { useSaveStore } from 'pages/audience/shared/save/hooks/context';

import { SaveContext } from './save.context';

const SaveProvider = ({ children }: { children: React.ReactNode }) => {
  return <SaveContext.Provider value={useSaveStore()}>{children}</SaveContext.Provider>;
};

export default SaveProvider;
